import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { pinnableSuggestions } from "../../utils/fanHubProfile";

const SuggestedWidgets = ({ suggestions = [], onPin, disabled }) => {
  const rows = pinnableSuggestions(suggestions);
  if (!rows.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Suggested
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        From your profile. Pinning adds a widget — it does not change who you
        follow.
      </Typography>
      {rows.map((row) => (
        <Box
          key={row.key}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            py: 1,
          }}
        >
          <Typography variant="body2">{row.widget?.title || row.key}</Typography>
          <Button
            size="small"
            variant="outlined"
            disabled={disabled}
            onClick={() => onPin(row)}
          >
            Pin
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default SuggestedWidgets;
